<div class="main-container">

  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>

  <!-- Top Gradient Header -->
  <app-header></app-header>

  <!-- Content Area -->
  <div class="content-wrapper">

    <div class="archive-card">

      <h1 class="title">Cognos Controller Archive </h1>

      <div class="status-badge">
        <strong>System Status:</strong>
        <span>Decommissioned – April 2026</span>
      </div>

      <section class="section">
        <h2>System Overview</h2>

        <p><strong>System Name:</strong> Cognos Controller</p>
        <p><strong>Archive Purpose:</strong> Historical Reference</p>

        <p class="description">
          This archive contains read-only historical data extracts from Cognos Controller,
          retained following system decommissioning. The system itself is no longer operational.
          No data in this archive is updated or refreshed.
        </p>
      </section>

      <section class="section">
        <h2>What This Archive Contains</h2>
        <ul class="main-list">
          <li>
            Balance Sheet Statements (BS02 – Sky Reporting, BS04 – Comcast Reporting)
            & P&L Statements (PL02 – Sky Reporting, PL04 – Comcast Reporting)

            <strong>
              NB:Each of the above statement files contains worksheets numbered 1–4,
              corresponding to the following reports: BS02, BS04, PL02 & PL04.
            </strong>
          </li>

          <li>Historical Rates for all Companies and all Currencies</li>
          <li>Currency Rates translated to GBP and USD</li>
          <li>Journals Entered</li>

        </ul>
      </section>

      <section class="section">
        <h2>Understanding Report Names</h2>

        <p><strong>Statement Naming Convention:</strong></p>
        <div class="code-block">
          [Year & Period]_[Territory Name]_[Closing Version]_[Actuality]_[Consolidation Type]_[Currency]
        </div>

        <p><strong>Example:</strong></p>
        <div class="code-block example">
          2312_A1000_GRFS_AM_CS_GBP
        </div>

        <p><strong>Other Files Naming Convention:</strong></p>
        <div class="code-block">
          [Year & Period]_[FileType]_[Actualities]_[Currency(s)]
        </div>

        <div class="code-block example">
          2212_HistoricalRates_AAAM_ALLCURR <br>
          2212_CurrRate_AAAM_GBP <br>
          2312_JOURNALS_AAAM_LC
        </div>

        <div class="info-note">
          <p>• Actuality <strong>AM</strong> came into effect from 2212.</p>
          <p>• No journals were entered after 2412.</p>
        </div>
        <div class="info-note">
          <p>• <strong>Actuality AA</strong> - preliminary consolidated load where FX translated at WD-3 rates</p>
          <p>• <strong>Actuality AM</strong> - final consolidated load where FX translated at WD1 rates. (Some journals only posted in AM).</p>
          <p>• <strong>Consolidation Type CS</strong> - Sky Consolidation used by Sky Group.</p>
          <p>• <strong>Consolidation Type MG</strong> - Deconsolidation structure to bring in all the deconsolidation entities for producing the statutory accounts (e.g. 2999 for Sky UK Ltd, 2995 for SHS).</p>
          <p>• <strong>Closing version</strong> - Indicates the source of financial data presented, where GRFS is Group Finance Stat Version typically used by Sky Group and loaded into One stream.</p>
        </div>
      </section>
    </div>
  </div>
</div>
